import { SVGProps } from 'react';

export const TaskListCalendarImage = ({
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="64"
      height="60"
      viewBox="0 0 64 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <path
            d="M4 16C4 11.5817 7.58172 8 12 8H52C56.4183 8 60 11.5817 60 16V64H4V16Z"
            fill="white"
          />
          <path
            d="M59 16C59 12.134 55.866 9 52 9H12C8.13401 9 5 12.134 5 16V63H59V16ZM60 64H4V16C4 11.5817 7.58172 8 12 8H52C56.4183 8 60 11.5817 60 16V64Z"
            fill={`url(#paint0_${props.id})`}
          />
          <path
            d="M18 5C18 2.23858 20.2386 0 23 0C25.7614 0 28 2.23858 28 5V11C28 13.7614 25.7614 16 23 16C20.2386 16 18 13.7614 18 11V5Z"
            fill={`url(#paint1_${props.id})`}
          />
          <path
            d="M36 5C36 2.23858 38.2386 0 41 0C43.7614 0 46 2.23858 46 5V11C46 13.7614 43.7614 16 41 16C38.2386 16 36 13.7614 36 11V5Z"
            fill={`url(#paint2_${props.id})`}
          />
          <path
            d="M11 24.5C11 23.1193 12.1193 22 13.5 22H39.5C40.8807 22 42 23.1193 42 24.5C42 25.8807 40.8807 27 39.5 27H13.5C12.1193 27 11 25.8807 11 24.5Z"
            fill={`url(#paint3_${props.id})`}
          />
          <path
            d="M26 33.5C26 32.1193 27.1193 31 28.5 31H50.5C51.8807 31 53 32.1193 53 33.5C53 34.8807 51.8807 36 50.5 36H28.5C27.1193 36 26 34.8807 26 33.5Z"
            fill={`url(#paint4_${props.id})`}
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id={`paint0_${props.id}`}
          x1="40"
          y1="-14.5"
          x2="18.5"
          y2="67.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="0.780666" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={`paint1_${props.id}`}
          x1="23"
          y1="0"
          x2="23"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
        <linearGradient
          id={`paint2_${props.id}`}
          x1="41"
          y1="0"
          x2="41"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
        <linearGradient
          id={`paint3_${props.id}`}
          x1="26.5"
          y1="22"
          x2="26.5"
          y2="27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
        <linearGradient
          id={`paint4_${props.id}`}
          x1="39.5"
          y1="31"
          x2="39.5"
          y2="36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
        <clipPath id={`clip0_${props.id}`}>
          <rect width="64" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
